import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../api";
import { useUser } from "../context/UserContext";
import { fmtVND, fmtCurrency, fmtDateTime } from "../lib/format";
import StatusChip from "../components/StatusChip";
import { ArrowRight } from "lucide-react";

export default function Payouts() {
  const { activeUserId } = useUser();
  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!activeUserId) return;
    setLoading(true);
    api.payouts(activeUserId).then((p) => {
      setPayouts(p);
      setLoading(false);
    });
  }, [activeUserId]);

  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-3xl font-bold text-slate-900">Payouts</h1>
        <p className="text-sm text-slate-500 mt-1">
          All withdrawal requests, newest first.
        </p>
      </header>

      <div className="space-y-3">
        {loading && <div className="text-sm text-slate-500">Loading…</div>}
        {!loading && payouts.length === 0 && (
          <div className="rounded-2xl border border-dashed border-slate-300 p-8 text-center text-sm text-slate-500">
            No payouts yet. Start a withdrawal from your wallet.
          </div>
        )}
        {payouts.map((p) => (
          <Link
            key={p.id}
            to={`/payouts/${p.id}`}
            data-testid={`payout-row-${p.id}`}
            className="group flex items-center justify-between gap-4 rounded-2xl border border-slate-200 bg-white p-5 hover:border-teal-700 hover:shadow-sm transition-colors"
          >
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-display text-lg font-bold text-slate-900 tabular-nums">
                  {fmtCurrency(p.net_amount, p.payout_currency)}
                </span>
                <span className="text-xs text-slate-400">
                  ({fmtVND(p.amount_vnd)} gross)
                </span>
                <StatusChip status={p.status} />
              </div>
              <div className="mt-1 flex items-center gap-2 text-xs text-slate-500 flex-wrap">
                <span>{p.destination_snapshot?.bank_name}</span>
                <span>•</span>
                <span>{fmtDateTime(p.created_at)}</span>
                {p.rail_reference_id && (
                  <>
                    <span>•</span>
                    <code className="rounded bg-slate-100 px-1.5 py-0.5 font-mono text-[10px] text-slate-700">
                      {p.rail_reference_id}
                    </code>
                  </>
                )}
              </div>
            </div>
            <ArrowRight className="h-5 w-5 text-slate-400 group-hover:text-teal-700 group-hover:translate-x-0.5 transition-transform" />
          </Link>
        ))}
      </div>
    </div>
  );
}
